export const ORDER_ITEM_UNIT_PRICE = 50;

export function calculateOrderTotal(
	lines: ReadonlyArray<{ quantity: number }>,
	isDraft = false,
	servicePrice = 0,
): number {
	const linesTotal = lines.reduce(
		(acc, line) => acc + ORDER_ITEM_UNIT_PRICE * line.quantity,
		0,
	);

	if (isDraft) return linesTotal;

	return servicePrice + linesTotal;
}
